/** @format */

import React from "react"
import { DropzoneArea } from "material-ui-dropzone"
import Fieldz from "../../../../functions/Fieldz"
import { Formik } from "formik"
import { Button } from "@material-ui/core"
import { useDispatch, useSelector } from "react-redux"
import { actions } from "../redux"
import { UploadFiles } from "../crud"

export default (props) => {
  const ownerState = useSelector((state) => state.owner)
  const { user } = useSelector((state) => state.auth)
  console.log("fourth ownerState", ownerState)
  const dispatch = useDispatch()

  return (
    <div className="p-5">
      <h2
        className="col-4 col-md-3"
        style={{
          borderBottom: "3px solid #6dd06d",
          padding: "10px",
          whiteSpace: "nowrap",
        }}
      >
        <b>آپلود مدارک</b>
      </h2>
      <Formik
        enableReinitialize
        initialValues={{ files: [] }}
        onSubmit={(values) => {
          if (values.files.length >= 4) {
            dispatch(actions.getAllImages(values.files))

            props.handleComplete()
          }
        }}
      >
        {({ handleSubmit, setFieldValue, errors, touched, values }) => {
          return (
            <div className="d-flex flex-wrap">
              {Fieldz({
                name: "uploadZone",
                placeholder: "بارگذاری تصویر",
                type: "uploadZone",
                acceptedFiles: ["image/jpeg", "image/png", "image/bmp"],
                setValue: (files) => {
                  let file = files[0]

                  if (file) {
                    setFieldValue("files", [
                      ...values.files,
                      {
                        ContractDocTypeId: 1,
                        images: files,
                        title: "کارت ماشین",
                        description: "کارت ماشین",
                      },
                    ])
                  }
                },
                title: (
                  <h4
                    className="my-auto mr-auto"
                    style={{ marginBottom: "1rem" }}
                  >
                    کارت ماشین
                  </h4>
                ),
                errors,
                touched,
              })}
              {Fieldz({
                name: "uploadZone",
                placeholder: "بارگذاری تصویر",
                type: "uploadZone",
                acceptedFiles: ["image/jpeg", "image/png", "image/bmp"],
                setValue: (files) => {
                  let file = files[0]

                  if (file) {
                    setFieldValue("files", [
                      ...values.files,
                      {
                        ContractDocTypeId: 2,
                        images: files,
                        title: "شناسنامه",
                        description: "شناسنامه",
                      },
                    ])
                  }
                },
                title: (
                  <h4
                    className="my-auto mr-auto"
                    style={{ marginBottom: "1rem" }}
                  >
                    شناسنامه
                  </h4>
                ),
                errors,
                touched,
              })}
              {Fieldz({
                name: "uploadZone",
                placeholder: "بارگذاری تصویر",
                type: "uploadZone",
                acceptedFiles: ["image/jpeg", "image/png", "image/bmp"],
                setValue: (files) => {
                  let file = files[0]

                  if (file) {
                    setFieldValue("files", [
                      ...values.files,
                      {
                        ContractDocTypeId: 3,
                        images: files,
                        title: "بیمه نامه",
                        description: "بیمه نامه",
                      },
                    ])
                  }
                },
                title: (
                  <h4
                    className="my-auto mr-auto"
                    style={{ marginBottom: "1rem" }}
                  >
                    بیمه نامه
                  </h4>
                ),
                errors,
                touched,
              })}
              {Fieldz({
                name: "uploadZone",
                placeholder: "بارگذاری تصویر",
                type: "uploadZone",
                acceptedFiles: ["image/jpeg", "image/png", "image/bmp"],
                setValue: (files) => {
                  let file = files[0]

                  if (file) {
                    setFieldValue("files", [
                      ...values.files,
                      {
                        ContractDocTypeId: 4,
                        images: files,
                        title: "کارت هوشمند",
                        description: "کارت هوشمند",
                      },
                    ])
                  }
                },
                title: (
                  <h4
                    className="my-auto mr-auto"
                    style={{ marginBottom: "1rem" }}
                  >
                    کارت هوشمند
                  </h4>
                ),
                errors,
                touched,
              })}
              <div
                className="d-flex align-items-center flex-wrap col-12"
                style={{ marginBlock: "3rem 2rem" }}
              >
                <div className="col-12 col-md-6 my-3">
                  <Button
                    className="w-100"
                    style={{
                      height: "4rem",
                      backgroundColor: "#6dd06d",
                      borderRadius: "13px",
                    }}
                    onClick={() => {
                      handleSubmit()
                    }}
                  >
                    <h6 className="my-auto text-white">مرحله بعد</h6>
                  </Button>
                </div>
                <div className="col-12 col-md-6  my-3">
                  <Button
                    className="w-100"
                    onClick={() => {
                      props.handleBack()
                    }}
                    style={{
                      height: "4rem",
                      backgroundColor: "#d9d9d9",
                      borderRadius: "13px",
                    }}
                  >
                    <h6 className="my-auto text-white">بازگشت</h6>
                  </Button>
                </div>
              </div>
            </div>
          )
        }}
      </Formik>
    </div>
  )
}
